export default __webpack_public_path__ + "static/media/record-overlay-2.8b675bc0.svg";